import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import { append, map, filter } from "ramda";
const {
  useReducer
} = React;

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD":
      return append(action.component, state);

    case "REMOVE":
      return filter(i => i.id !== action.id, state);

    case "UPDATE":
      return map(i => i.id === action.id ? { ...i,
        value: action.value
      } : i, state);

    default:
      throw new Error("You must pass a valid action");
  }
};

const DocumentState = React.createContext({});
const DocumentDispatch = React.createContext(null);

const DocumentProvider = props => {
  const defaultState = [];
  const [state, dispatch] = useReducer(reducer, defaultState); // TODO: Try to encode the state into the URL and be able to resume
  // when something is put into the URL bar
  // TODO: Loading...

  return ___EmotionJSX(DocumentDispatch.Provider, {
    value: dispatch
  }, ___EmotionJSX(DocumentState.Provider, {
    value: state
  }, props.children));
};

export { DocumentProvider, DocumentState, DocumentDispatch };